var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.show)?_c('h2',{staticClass:"ma-6 text-center"},[_vm._v("ไม่พบหน้านี้")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }